import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  fill: "none",
  height: "14",
  viewBox: "0 0 17 14",
  width: "17",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"#fff\"><path d=\"m0 4h4v6h-4z\"></path><path d=\"m3 4 5-4v14l-5-4z\"></path><g clip-rule=\"evenodd\" fill-rule=\"evenodd\"><path d=\"m11.0021 7.00022c0-.93556-.4271-1.77056-1.10071-2.32233l1.26741-1.54718c1.1174.91534 1.8333 2.30923 1.8333 3.86951 0 1.56251-.7179 2.95814-1.8381 3.87338l-1.26548-1.5487c.67528-.55174 1.10358-1.3878 1.10358-2.32468z\"></path><path d=\"m14.9995 6.99984c0-2.1827-.9978-4.13153-2.5659-5.41688l1.2678-1.546784c2.0117 1.648924 3.2981 4.156474 3.2981 6.963664 0 2.80776-1.2869 5.31576-3.2993 6.96466l-1.2676-1.547c1.5687-1.2854 2.5669-3.23453 2.5669-5.41766z\"></path></g></g>", 1)
  ]))]))
}
export default { render: render }